module.exports = __webpack_public_path__ + "static/neutraldinosaurhamper-9fa2ab408759be49c15087f3c1315667.jpeg";